import '../styles/opensource.css'
function Opensource() {
  return (
    <div className="opensource">
        Page under Construction !<br/>
     Visit <a href="https://github.com/codeflow201">https://github.com/codeflow201</a> for our latest opensource projects !
    </div>
  );
}

export default Opensource;
